import {
    Text,
    TextTag,
    TokenTextAppearance,
    TokenTextColor,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import styled from 'styled-components'
import {Promotion} from '../../../types/singleModelInterface'
import {getPromoTitle} from '../../../utils/promos/getPromoTitle'
import PromotionPrice, {hasPromotionPrice} from '../ui/PromotionPrice'

const PROMOTION_TITLE_ID = 'coupon-request-promotion-title'

const SummaryContainer = styled.section`
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.size.static150};
    padding: ${(props) => props.theme.size.dynamic0050};
    border: ${(props) => props.theme.size.border.active} solid
        ${(props) => props.theme.colors.border.divider};
    border-radius: ${(props) => props.theme.size.borderRadius.card};
`

const SummaryText = styled(Text)`
    margin: 0;
    overflow-wrap: anywhere;

    /* The layer containers hide \`:empty\` elements, \`<br>\` of the CMS copy included */
    && br {
        display: inline;
    }
`

export interface FormPromotionSummaryProps {
    promotion: Promotion
}

/**
 * Recap of the promotion the quotation is requested for, shown at the top of
 * the form: its price copy includes the financing figures (TAN, TAEG, etc.).
 */
export function FormPromotionSummary({
    promotion,
}: FormPromotionSummaryProps): React.JSX.Element {
    const subTitle = promotion.motorization || promotion.sub_title

    return (
        <SummaryContainer aria-labelledby={PROMOTION_TITLE_ID}>
            {subTitle ? (
                <SummaryText
                    tag={TextTag.p}
                    appearance={TokenTextAppearance.copy200}
                    color={TokenTextColor.secondary}
                >
                    {subTitle}
                </SummaryText>
            ) : undefined}

            <SummaryText
                id={PROMOTION_TITLE_ID}
                tag={TextTag.h3}
                appearance={TokenTextAppearance.headline200}
                bold
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: getPromoTitle(
                            promotion.title,
                            promotion.is_promo_service,
                            promotion.customizable_title
                        ),
                    }}
                />
            </SummaryText>

            {hasPromotionPrice(promotion) ? (
                <SummaryText
                    tag={TextTag.div}
                    appearance={TokenTextAppearance.copy200}
                >
                    <PromotionPrice
                        price={promotion.price}
                        price_prefix={promotion.price_prefix}
                        price_suffix={promotion.price_suffix}
                    />
                </SummaryText>
            ) : undefined}
        </SummaryContainer>
    )
}
